<skl-dialog-content-ins>
	<skl-dialog-header-ins
		[title]="viewModel.title"
		(onClose)="onCancel()">
	</skl-dialog-header-ins>

	<ins-content>
		<skl-form-container>
			<div class="grid">
				<div [ngClass]="viewModel.isDateShown('FromTo') ? 'col-1-3' : 'col-1-2'">
					<ins-form-field
						[skl-focus-by]
						[label]="'ui.filter-chips.filter-date-dialog.form.chosen-period' | translate">
						<ins-select
							id="filter-date-dialog-chosen-period"
							display-text="label"
							[converter]="viewModel.periodConverter"
							[(ngModel)]="viewModel.period">
							@for (item of viewModel.periods; track item) {
								<ins-option
									[value]="item">
									{{item.label}}
								</ins-option>
							}
						</ins-select>
					</ins-form-field>
				</div>
				@if (viewModel.isDateShown('FromTo')) {
					<div class="col-1-3">
						<ins-form-field
							[label]="'ui.filter-chips.filter-date-dialog.form.from' | translate">
							<ins-datepicker
								id="filter-date-dialog-from"
								[(ngModel)]="viewModel.from">
							</ins-datepicker>
						</ins-form-field>
					</div>
					<div class="col-1-3">
						<ins-form-field
							[label]="'ui.filter-chips.filter-date-dialog.form.to' | translate">
							<ins-datepicker
								id="filter-date-dialog-to"
								[(ngModel)]="viewModel.to">
							</ins-datepicker>
							<div slot="end" [ngClass]="{ 'display--none': !viewModel.isFromToPeriodInvalid() }">
								<skl-icon
									[tooltip]="{text: 'ui.filter-chips.filter-date-dialog.form.to-error' | translate, color: 'error'}"
									color="error"
									name="exclamation-circle">
								</skl-icon>
							</div>
						</ins-form-field>
					</div>
				}
				@if (viewModel.isDateShown('Day')) {
					<div class="col-1-2">
						<ins-form-field
							[label]="'ui.filter-chips.filter-date-dialog.form.chosen-day' | translate">
							<ins-datepicker
								id="filter-date-dialog-chosen-day"
								[(ngModel)]="viewModel.chosenDay">
							</ins-datepicker>
						</ins-form-field>
					</div>
				}
				@if (viewModel.isDateShown('Month')) {
					<div class="col-1-2">
						<ins-form-field
							[label]="'ui.filter-chips.filter-date-dialog.form.chosen-month' | translate">
							<ins-datepicker
								id="filter-date-dialog-chosen-month"
								[(ngModel)]="viewModel.chosenMonth"
								type="month">
							</ins-datepicker>
						</ins-form-field>
					</div>
				}
			</div>
		</skl-form-container>
	</ins-content>

	<ins-footer class="dialog__buttons">
		<skl-button
			id="filter-date-dialog-cancel-button"	
			(click)="onCancel()"
		>
			{{'ui.filter-chips.filter-date-dialog.buttons.cancel' | translate}}
		</skl-button>
		<skl-button
			id="filter-date-dialog-choose-button"
			(click)="chooseDate()"
		>
			{{'ui.filter-chips.filter-date-dialog.buttons.choose' | translate}}
		</skl-button>
	</ins-footer>
</skl-dialog-content-ins>